import { render, staticRenderFns } from "./lazyblock_private_content.vue?vue&type=template&id=057bec44&scoped=true"
import script from "./lazyblock_private_content.vue?vue&type=script&lang=js"
export * from "./lazyblock_private_content.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_private_content.vue?vue&type=style&index=0&id=057bec44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bec44",
  null
  
)

export default component.exports